import { useRef } from 'react'
import { Volume1, Volume2, VolumeX } from 'lucide-react'
import styles from './PublicVolumeControl.module.css'

type PublicVolumeControlProps = {
  buttonClassName?: string
  className?: string
  onChange: (volume: number) => void
  onInteract?: () => void
  tone?: 'light' | 'dark'
  volume: number
}

export const PublicVolumeControl = ({
  buttonClassName,
  className,
  onChange,
  onInteract,
  tone = 'light',
  volume
}: PublicVolumeControlProps) => {
  const previousVolumeRef = useRef(volume > 0 ? volume : 0.8)
  const Icon = volume <= 0 ? VolumeX : volume < 0.5 ? Volume1 : Volume2

  const setVolume = (nextVolume: number): void => {
    if (nextVolume > 0) {
      previousVolumeRef.current = nextVolume
    }

    onChange(nextVolume)
    onInteract?.()
  }

  const toggleMuted = (): void => {
    setVolume(volume > 0 ? 0 : previousVolumeRef.current)
  }

  return (
    <div
      className={[styles.root, tone === 'dark' ? styles.dark : '', className].filter(Boolean).join(' ')}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      onTouchStart={(event) => event.stopPropagation()}
    >
      <button
        className={[styles.button, buttonClassName].filter(Boolean).join(' ')}
        onClick={toggleMuted}
        type="button"
        aria-label={volume > 0 ? 'Mute audio' : 'Unmute audio'}
        title="Volume"
      >
        <Icon size={16} />
      </button>
      <div className={styles.popover}>
        <input
          aria-label="Volume"
          className={styles.slider}
          max={1}
          min={0}
          onChange={(event) => setVolume(Number(event.target.value))}
          step={0.01}
          type="range"
          value={volume}
        />
      </div>
    </div>
  )
}
